import { render, staticRenderFns } from "./InventoryLock.vue?vue&type=template&id=b2d47c42&scoped=true"
import script from "./InventoryLock.vue?vue&type=script&lang=js"
export * from "./InventoryLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d47c42",
  null
  
)

export default component.exports